import InnerNav from "../../../components/InnerNav/InnerNav";
import Zodiac from "../../../components/ZodiacSign/Zodiac";
import "./Kua.scss";
import arrow from "../../../assets/arrow.png";
import { useState } from "react";
import Footer from "../../../components/Footer/Footer";
import { Link } from "react-router-dom";
import axios from "axios";



export const destinyProfiles = {
  1: {
    title: "Kua Number 1 – The Flowing Energy",
    keywords: "Wisdom · Adaptability · Flow",
    overview:
      "Kua Number 1 represents flowing, adaptable energy. You align best with movement, flexibility and calm decision-making.",
    strengths: [
      "Adaptable energy",
      "Strategic thinking",
      "Ability to move with change"
    ],
    challenges: [
      "Emotional sensitivity",
      "Overthinking directions",
      "Energy imbalance when rushed"
    ],
    guidance:
      "Stay flexible. Align your surroundings to support calm focus and clarity."
  },

  2: {
    title: "Kua Number 2 – The Nurturing Energy",
    keywords: "Stability · Support · Grounding",
    overview:
      "Kua Number 2 reflects grounded, nurturing energy. You thrive in stable and supportive environments.",
    strengths: [
      "Grounded presence",
      "Supportive energy",
      "Ability to create harmony"
    ],
    challenges: [
      "Over-dependence",
      "Resistance to movement",
      "Low motivation in change"
    ],
    guidance:
      "Strengthen self-belief. Balance support with independence."
  },

  3: {
    title: "Kua Number 3 – The Growth Energy",
    keywords: "Expansion · Initiative · Action",
    overview:
      "Kua Number 3 carries strong growth and action-oriented energy. You thrive in dynamic and forward-moving environments.",
    strengths: [
      "Initiative-driven energy",
      "Growth mindset",
      "Motivational force"
    ],
    challenges: [
      "Restlessness",
      "Impulsive direction choices",
      "Energy imbalance"
    ],
    guidance:
      "Direct your energy with purpose. Consistent alignment brings stability."
  },

  4: {
    title: "Kua Number 4 – The Harmonising Energy",
    keywords: "Creativity · Balance · Communication",
    overview:
      "Kua Number 4 reflects harmonious, creative and flexible energy. You benefit from balanced and peaceful surroundings.",
    strengths: [
      "Creative flow",
      "Balanced thinking",
      "Gentle adaptability"
    ],
    challenges: [
      "Indecisiveness",
      "Energy dispersion",
      "Sensitivity to surroundings"
    ],
    guidance:
      "Create structured harmony. Balance creativity with stability."
  },

  5: {
    title: "Kua Number 5 – The Central Energy",
    keywords: "Balance · Transformation · Control",
    overview:
      "Kua Number 5 represents central and transformative energy. Your balance depends heavily on correct directional alignment.",
    strengths: [
      "Strong core energy",
      "Transformative power",
      "Leadership potential"
    ],
    challenges: [
      "Energy instability",
      "High pressure",
      "Direction sensitivity"
    ],
    guidance:
      "Maintain balance. Proper Feng Shui alignment is essential for stability."
  },

  6: {
    title: "Kua Number 6 – The Structured Energy",
    keywords: "Discipline · Authority · Order",
    overview:
      "Kua Number 6 carries disciplined and authoritative energy. You perform best in structured and orderly environments.",
    strengths: [
      "Strong discipline",
      "Focused direction",
      "Leadership alignment"
    ],
    challenges: [
      "Rigidity",
      "Over-control",
      "Resistance to flexibility"
    ],
    guidance:
      "Allow flexibility. Balance authority with openness."
  },

  7: {
    title: "Kua Number 7 – The Joyful Energy",
    keywords: "Creativity · Enjoyment · Lightness",
    overview:
      "Kua Number 7 reflects joyful and expressive energy. You thrive in environments that encourage comfort and positivity.",
    strengths: [
      "Positive energy flow",
      "Creative expression",
      "Enjoyment-driven alignment"
    ],
    challenges: [
      "Distraction",
      "Energy leakage",
      "Comfort dependency"
    ],
    guidance:
      "Stay focused. Joy works best with mindful structure."
  },

  8: {
    title: "Kua Number 8 – The Stable Energy",
    keywords: "Stability · Strength · Consistency",
    overview:
      "Kua Number 8 represents strong, stable and grounding energy. You benefit from consistent and rooted environments.",
    strengths: [
      "High stability",
      "Strong endurance",
      "Grounded alignment"
    ],
    challenges: [
      "Resistance to change",
      "Over-seriousness",
      "Energy stagnation"
    ],
    guidance:
      "Introduce gentle movement. Stability grows with balance."
  },

  9: {
    title: "Kua Number 9 – The Visionary Energy",
    keywords: "Clarity · Inspiration · Illumination",
    overview:
      "Kua Number 9 carries bright, visionary and inspirational energy. You thrive when surrounded by clarity and light.",
    strengths: [
      "Inspirational alignment",
      "Strong clarity",
      "High motivation"
    ],
    challenges: [
      "Energy burnout",
      "Overexposure",
      "Emotional intensity"
    ],
    guidance:
      "Balance brightness with rest. Alignment restores energy."
  }
};


const Kua = () => {

  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    year: "2000",
    month: "May",
    day: "26",
    gender: "male" // ✅ DEFAULT, NO UI
  });


  const [resultData, setResultData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showReport, setShowReport] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { firstName, lastName, year, month, day } = formData;
    const birthDay = Number(day);
    const birthMonth = new Date(`${month} 1, 2000`).getMonth() + 1;
    const birthYear = Number(year);

    try {
      setLoading(true);

      const { gender } = formData;

      const res = await axios.get(
        `https://core-c343.onrender.com/api/lucky-number` +
        `?firstName=${firstName}` +
        `&lastName=${lastName}` +
        `&birthYear=${birthYear}` +
        `&birthMonth=${birthMonth}` +
        `&birthDay=${birthDay}` +
        `&gender=${gender}`
      );


      setResultData(res.data);
      setShowReport(true);
    } catch (err) {
      setResultData({
        error: "Unable to generate your Destiny Number report. Please try again.",
      });
      setShowReport(true);
    } finally {
      setLoading(false);
    }
  };

  const handleTryAgain = () => {
    setShowReport(false);
    setResultData(null);
  };

  const destinyNum = resultData?.data?.numerology?.kuaNumber;
  const profile = destinyNum ? destinyProfiles[destinyNum] : null;

  return (
    <div className="destiny-container">
      <InnerNav />

      <div className="destiny-content">
        <Zodiac />

        <div className="left-numerology">

          {/* FORM VIEW */}
          {!showReport && (
            <>
              <div className="header">
                <h1>Kua Number Calculator</h1>
                <p>
                  Discover your <strong>lucky directions and Feng Shui energy flow</strong> based on your birth year.
                </p>
              </div>

              <div className="form-card">
                <form onSubmit={handleSubmit} className="form-grid">

                  <input
                    name="firstName"
                    placeholder="First Name"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />

                  <input
                    name="middleName"
                    placeholder="Middle Name (Optional)"
                    value={formData.middleName}
                    onChange={handleChange}
                  />

                  <input
                    name="lastName"
                    placeholder="Last Name"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />

                  <div className="dob-grid">
                    <select name="day" value={formData.day} onChange={handleChange}>
                      {[...Array(31)].map((_, i) => (
                        <option key={i + 1}>{i + 1}</option>
                      ))}
                    </select>

                    <select name="month" value={formData.month} onChange={handleChange}>
                      {[
                        "January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                      ].map((m) => (
                        <option key={m}>{m}</option>
                      ))}
                    </select>

                    <select name="year" value={formData.year} onChange={handleChange}>
                      {Array.from({ length: 110 }).map((_, i) => {
                        const y = 2025 - i;
                        return <option key={y}>{y}</option>;
                      })}
                    </select>
                  </div>
                  <select
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    required
                  >
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>


                  <button type="submit" className="primary-btn" disabled={loading}>
                    {loading ? "Generating..." : "Show My Destiny Number"}
                  </button>

                </form>
              </div>
            </>
          )}

          {/* REPORT VIEW */}
          {showReport && (
            <div className="report-card">

              <h1>Your Kua Number Report</h1>

              {resultData?.error ? (
                <p className="error-text">{resultData.error}</p>
              ) : (
                <>
                  <div className="hero-number-box">
                    <div className="number-circle">{destinyNum}</div>
                    <h2>{profile?.title}</h2>
                    <p className="keywords">{profile?.keywords}</p>
                  </div>

                  <div className="report-section">
                    <h3>Overview</h3>
                    <p>{profile?.overview}</p>
                  </div>

                  <div className="report-section">
                    <h3>Your Strengths</h3>
                    <ul>{profile?.strengths.map((s, i) => <li key={i}>{s}</li>)}</ul>
                  </div>

                  <div className="report-section">
                    <h3>Your Challenges</h3>
                    <ul>{profile?.challenges.map((c, i) => <li key={i}>{c}</li>)}</ul>
                  </div>

                  <div className="report-section">
                    <h3>Guidance</h3>
                    <p>{profile?.guidance}</p>
                  </div>
                </>
              )}

              <button className="try-again-btn" onClick={handleTryAgain}>
                Try Again
              </button>
            </div>
          )}
        </div>

        {/* RIGHT SIDEBAR */}
        <div className="right-numerology">
          <h4>Related Links</h4>
          <div className="right-links">
            <Link to="/numerology/luckynum"><p><img src={arrow} /> Lucky Number</p></Link>
            <Link to="/numerology/chinese-lucky"><p><img src={arrow} /> Chinese Lucky</p></Link>
            <Link to="/numerology/unlucky"><p><img src={arrow} /> Unlucky Number</p></Link>
            <Link to="/numerology/life-path"><p><img src={arrow} /> Life Path</p></Link>
            <Link to="/numerology/destiny"><p><img src={arrow} /> Destiny Number</p></Link>
            <Link to="/numerology/birth"><p><img src={arrow} /> Birth or Root Number</p></Link>
            <Link to="/numerology/soul"><p><img src={arrow} /> Soul Urge Number</p></Link>
            <Link to="/numerology/name"><p><img src={arrow} /> Name Number</p></Link>
            <Link to="/numerology/balance"><p><img src={arrow} /> Balance Number</p></Link>
            <Link to="/numerology/lo-shu-grid"><p><img src={arrow} /> Lo Shu Grid Analysis</p></Link>
            <Link to="/numerology/kua"><p><img src={arrow} /> Kua Number</p></Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Kua;